import { ErrorIcon } from "@src/assets";

interface Props {
  title: string;
  description?: string;
}
export const ErrorView = ({ title, description }: Props) => {
  return (
    <div className="flex flex-col gap-5 w-full h-full items-center justify-center overflow-hidden">
      <ErrorIcon className="flex-shrink-0 w-[50px] h-[50px]" />
      <div className="flex flex-col w-full max-w-full items-center justify-center min-h-0">
        <div className="flex-shrink-0 text-2xl font-bold text-text_primary">
          {title}
        </div>
        <div className="text-md text-text_primary text-center overflow-auto w-full break-words">
          {description || "Please try again later"}
        </div>
      </div>
    </div>
  );
};
